/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/date_format.json`.

import type { DefinitionDocs } from '../../definition_types';

const docs: DefinitionDocs = {
  description: 'Returns a string representation of a date, in the provided format.',
  examples: [
    'FROM employees\n| KEEP first_name, last_name, hire_date\n| EVAL hired = DATE_FORMAT("yyyy-MM-dd", hire_date)',
  ],
  params: {
    date: 'Date expression. If `null`, the function returns `null`.',
    dateFormat: 'Date format (optional).  If no format is specified, the `yyyy-MM-dd\'T\'HH:mm:ss.SSSZ` format is used. If `null`, the function returns `null`.',
  },
};

export default docs;
